// Field.js

import { useState, useEffect, useMemo} from "react";
import { Box, Text, Image, CheckBox, grommet, Grommet,  Spinner} from "grommet";
import { Trophy, Achievement, Inherit, SubtractCircle, Dislike, RadialSelected, Norton} from "grommet-icons";
import { useFetch } from "use-http";
import { deepMerge } from "grommet/utils";

const customTheme = deepMerge(grommet, {
    global: {
        colors: {
            brand: 'neutral-3',
            text: "neutral-3",
            border: "neutral-3",
            selected: "light-4",
        },    
    },
    box: {
        extend: ({ hoverIndicator }) => {
            if (hoverIndicator) {            
                return `
                    &:hover {
                        cursor: ${"pointer"};
                    }
                    `;
            }
        }
    }
});

const Field = (props) => {
    const {plants, selectedRow, selectedCol, onScionClick, onCheckedChange, selectedField} = props;
    const { loading } = useFetch();
    // console.log(" 🖖 plants  on field  >> >>> ", plants);
    // console.log("selectedRow >> >>> ", selectedRow);
    // console.log("selectedCol >> >>> ", selectedCol);
    // console.log(" 🖖 props In Field >> >>> ", props);
    const [maxRow, setMaxRow] = useState(0);
    const [maxCol, setMaxCol] = useState(0);    
    
  // will be executed 1 time because the dependency array is empty
    const maxVinesOnRow = useMemo(
        () => (plants && plants.length > 0 && plants[0].IsSeedling !== 1 ? 120 : 80), []
    );

    useEffect(() => {
        if (selectedField && selectedField.FieldType === 1)
        {
             // sukka
            if((selectedRow !== '' && selectedRow !== 0 && Number(selectedRow) >= selectedField.RowFrom && Number(selectedRow) <= selectedField.RowTo))
                setMaxRow( Number(selectedRow) );
            setMaxCol(selectedField.VinesOnRow); 
        } else {
            // station
            let rows = 0;
            let cols = 0;

            plants.forEach(item => {   
                if (item.Row > rows) 
                {
                    rows = item.Row;
                }
                    
                if (item.Column > cols) 
                {
                    cols = item.Column;
                }                        
            });

            setMaxRow(rows);
            setMaxCol(cols); 

            // console.log("max row on field >> ", rows);
            // console.log("max col on field >> ", cols);
            
        }
    },[plants])

    const findElementByRowCol = useMemo(() => {
        return (row, col) => {
          if (plants && plants.length > 0) {
            return plants.find(
              (element) => element.Row === row && element.Column === col
            );
          }
          return null;
        };
    }, [plants]);
 
    const DrawItem = (item) =>
    {
        // console.log("item in DrawItem on field >> ", item);
        // let bg = "#bed3be";
        let bg = "";
        let img = props.strongPlantImage;
        let isSecondary = false;
                
        let width="60px"                                    
        let height="60px" 
        let showSelectedTreatment = false;
        let showSelectedFather = false;

        if ((selectedField && selectedField.FieldType === 1 && item.IsSeedling !== 1)
            || (selectedField && selectedField.FieldType === 2 && item.IsSeedling === 1)) 
        {
            isSecondary = true;
            img = props.secondaryImage;
            bg = "#a0b8a0";
        
        } else {

            showSelectedTreatment = (item.IsSeedling !== 1 && item.TreatmentId === props.selectedTreatment && item.FinishedAt === null) ? true : false;
            showSelectedFather = (item.IsSeedling === 1 && item.FatherId === props.father) ? true : false;
            
            if (item !== null && (item.StatusID === 3 || item.IsSeeded === true))
            {
                bg = "#FFC3A1";
                img = props.weakPlantImage;
                width="60px"                                    
                height="60px"  
                    
                if (item.IsSeedling === 1 && item.MotherId === props.mother)      
                    bg="linear-gradient(#ffc3a1, #221a3e)"                  
            }

            if (item !== null && item.UprootedAt && item.IsSeedling !== 1)
            {
                bg = "rgba(162, 66, 61, 0.4)";
                img = props.weakPlantImage;
                width="60px"                                    
                height="60px"  
                    
                if (item.IsSeedling === 1 && item.MotherId === props.mother)      
                    bg="linear-gradient(rgba(162, 66, 61, 0.4), #221a3e)"                  
            }

            if (item.IsSeedling === 1 && item.StatusID !== 3  && item.IsSeeded !== true && item.MotherId === props.mother)
            bg="linear-gradient( #bed3be, #221a3e)"
            // bg="linear-gradient(to left, #bed3be, #221a3e)"  
        }            

        return(
            <Box margin={"xxsmall"} pad={"xxsmall"} border key={item.Id}
                width={{ width: '100px', min: '100px' }}
                height={{ height: '100px',  min: '100px' }}
                background={bg}           
                align="center"
                // if scion treatment is equal to selected, set border gradient

                style={ showSelectedTreatment === true 
                    ? {position:"relative", border: "10px solid",  borderImageSlice: 1,  borderWidth: "5px", borderImageSource: "linear-gradient(to left, #743ad5, #d53a9d)"} 
                    : (showSelectedFather === true) 
                        ? {position:"relative", border: "10px solid",  borderImageSlice: 1,  borderWidth: "5px", borderImageSource: "linear-gradient(to left, #743ad5, #d53a9d)"} 
                        : {position:"relative"} }

                justify="between"
            >
            
                <Box direction="row-responsive"  align="center"   justify="around">
                    <Text weight="bold"  size="small" >{item.SUID}</Text>
                </Box>
                <Box 
                    hoverIndicator={!isSecondary && !item.UprootedAt ? true : false}
                    style={{position:"absolute", left: "15%", top: "25%"}} >                             
                    <Image                 
                        size="contain"
                        src={img}
                        width={width}                                    
                        height={height}  
                        onClick={() => {
                            if (!isSecondary && !item.UprootedAt) {
                                props.setChosen(item);
                                if (item.IsSeedling === 1) {
                                    props.setShow(true);
                                } else {
                                    onScionClick(item.Id);
                                }
                            }
                            // The onClick will do nothing if isSecondary is true or item.UprootedAt is set
                        }}                             
                        primary                                                                 
                    />                    
                </Box> 

                {!isSecondary && !item.UprootedAt &&
                <Box style={{position:"absolute", left: "3%", bottom: "3%"}}  >
                    <CheckBox  value={1} 
                        checked={item.Checked} 
                        onChange={(event) =>  onCheckedChange(item, event.target.checked)}
                    /> 
                </Box>
                }

                {isSecondary && (item.IsSeedling !== 1) &&
                <Box 
                    style={{
                        position: "absolute",
                        left: "50%",
                        bottom: "-2px",
                        transform: "translateX(-50%)"
                    }}>
                    <Text weight="bold"  size="small" >{item.StationName}</Text>
                </Box>
                }

                {item.HasStation === 1 && (
                <Box style={{ position: "absolute", right: "23%", bottom: "3%" }}>
                    <Inherit color="#00739D" size="18px" />
                </Box>
                )}
                {item.StatusID === 1 && (
                <Box style={{ position: "absolute", right: "3%", bottom: "3%" }}>
                    <Achievement color="#047343" size="18px" />
                </Box>
                )} 
                {( item.StatusID === 3) && (
                <Box style={{position:"absolute", right: "3%", bottom: "3%"}}>
                    <Dislike  color="status-critical" size='18px' /> 
                </Box>  
                )}

                {( item.IsSeeded === true) && (
                <Box style={{position:"absolute", right: "3%", bottom: "23%"}} >
                    <RadialSelected  color="status-critical" size='18px'  /> 
                </Box>  
                )}                                  
            </Box>       
        );
    }

    const DrawEmpty = (rowNum, vineNum) =>
    {
        // console.log('In DrawEmpty function !!');

        const existingLocationIndex = (!selectedField || selectedField.FieldType === 2) ? null
                : props.newSeedlingLocations.findIndex(location => 
                    location.Row === rowNum && location.Col === vineNum
        );

        return(
            <Box margin={"xxsmall"} pad={"xxsmall"} border key={Math.random(100)}
                width={{ width: '100px', min: '100px' }}
                height={{ height: '100px',  min: '100px' }}
                align="center"
                style={{position:"relative" }}

                onClick={
                    (!selectedField || selectedField.FieldType === 2) 
                        ? null 
                        : () => {
                           
                            // If location is not found, add it; otherwise, remove it
                            if (existingLocationIndex === -1) {
                                const updatedLocations = [...props.newSeedlingLocations, { Row: rowNum, Col: vineNum }];
                                props.setNewSeedlingLocations(updatedLocations);
                            } else {
                                const updatedLocations = props.newSeedlingLocations.filter((_, index) => index !== existingLocationIndex);
                                props.setNewSeedlingLocations(updatedLocations);
                            }
                        }
                }
                    
            >

                <Box  hoverIndicator style={{position:"absolute", left: "20%", top: "15%"}} > 
                    {/* Display Norton icon only if clicked is false */}
                    {existingLocationIndex !== -1 && existingLocationIndex !== null  && (                                           
                    <Norton color="brand" style={{width: "60px", height: "60px" }} />      
                    )}          
                </Box> 

                <Box style={{position:"absolute", left: "7px", bottom: "1px"}} > 
                    <Text weight="bold" size="small" >{rowNum }</Text>
                </Box>
                <Box style={{position:"absolute", right: "3px", bottom: "1px"}} > 
                    <Text weight="bold" size="small">{vineNum }</Text>          
                </Box>
            </Box>
        );
    }    

    const DrawRow = (rowNum, vineNum) => {
        const row = [];
        let item = null;
        // console.log("Iמ DrawRow rowNum >> "+ rowNum);
        // console.log("Iמ DrawRow vineNum >> "+ vineNum);

        let i = (selectedField && selectedField.FieldType === 1) ? 1 : vineNum;
        let maxVine = (selectedField && selectedField.FieldType === 1) ? maxCol : ( (maxCol < maxVinesOnRow) ? maxCol - vineNum + i : maxVinesOnRow ) ;

        // console.log("Iמ DrawRow maxVinesOnRow >> "+ maxVinesOnRow);
        // console.log("Iמ DrawRow maxVine >> "+ maxVine);
        // console.log("Iמ DrawRow selectedRow >> "+ selectedRow);
        // console.log("Iמ DrawRow selectedCol >> "+ selectedCol);

        for (i; i <= maxVine; i++, vineNum++) {             
            item = findElementByRowCol(rowNum, vineNum);
            // console.log(' 🍇 item found >> ', item);
            if (item === null || item === undefined || (selectedRow !== '' && item.Row !== Number(selectedRow)) || (selectedCol !== '' && item.Column !== Number(selectedCol)))  
                row.push( DrawEmpty(rowNum, vineNum) );
            else                
                row.push( DrawItem(item) ); 
           
            if ((!selectedField || selectedField.FieldType === 2) && vineNum === maxVinesOnRow ) {
                // scions
                if (vineNum === plants[plants.length-1].Column) 
                    break;
                else {
                    i = 0;
                    vineNum = 0;
                    rowNum++;
                    maxVine = plants[plants.length-1].Column;
                }
            }             
        }
        return(row);
    }

    const DrawField = () => {
        const field = [];
        let bg = '';

        // console.log("Iמ DrawField f-n maxVinesOnRow >> "+ maxVinesOnRow);        
        //let currentRow = plants[0].IsSeedling === 1 ? 1 : plants[0].Row;
        let currentRow = (plants && plants.length > 0 && plants[0].IsSeedling != 1) ? plants[0].Row 
            : (selectedRow !== '' && selectedRow !== 0 && Number(selectedRow) >= selectedField.RowFrom && Number(selectedRow) <= selectedField.RowTo) 
                ? Number(selectedRow) : selectedField.RowFrom;
        // console.log("Iמ DrawField f-n currentRow >> "+ currentRow);

        // for scion run 'for' loop only once
        // let maRow = plants.length > 0 && plants[0].IsSeedling != 1 ? plants[0].Row : maxRow ;
        let maRow = selectedField && selectedField.FieldType === 1 ? maxRow : plants[0].Row ;
        // console.log("Iמ DrawField f-n maRow >> "+ maRow);

        let startCol = selectedField && selectedField.FieldType === 1 ? 1 : plants[0].Column;

        for (currentRow; currentRow <= maRow; currentRow++) {
            if (currentRow % 2 === 0)
                bg = "#Cbe0cb";
            else
                bg = "#bed3be";

            field.push(
                <Box  key={currentRow * Math.random(100)+currentRow}
                    direction="row"
                    flex={true}
                    wrap={true}
                    width={{ min: '120px' }}
                    height={{ min: '120px' }}
                    pad={"xsmall"}
                    background={bg}
                >
                    {DrawRow(currentRow, startCol)}
                    
                </Box>
            );
            // For seedlings only: always draw the field from the first column
            // console.logs();
            if(plants && plants.length === 0 || (plants && plants.length > 0 && plants[0].IsSeedling === 1))
                startCol = 1;            
        }
        return field;
    };

    // console.log(' (In fields.js plants.length >> ', plants.length);

    return (
        <Grommet theme={customTheme} > 
            <Box
                direction="row-responsive" 
                align="center"
                gap="medium"
            >

                {loading && (
                    <Box align="center" direction="row" gap="small" pad="small">
                        <Spinner /> <Text>Loading...</Text>
                    </Box>
                )}

                <Box >
                    {DrawField()}
                </Box>
            </Box>
        </Grommet> 
    );
};

export default Field;
